export default () => ({
    openItems: [],
    hashChangeHandler: null,

    init() {
        this.openItems = this.getItems()
            .filter((item) => item.hasAttribute('data-accordion-open'))
            .map((item) => this.getItemKey(item));

        this.openHashItem();

        this.hashChangeHandler = () => this.openHashItem();

        window.addEventListener('hashchange', this.hashChangeHandler);
        window.addEventListener('popstate', this.hashChangeHandler);
    },

    destroy() {
        if (!this.hashChangeHandler) {
            return;
        }

        window.removeEventListener('hashchange', this.hashChangeHandler);
        window.removeEventListener('popstate', this.hashChangeHandler);
        this.hashChangeHandler = null;
    },

    getItems() {
        return Array.from(this.$el.querySelectorAll('[data-accordion-item]'));
    },

    getItemKey(item) {
        return item?.dataset.accordionKey || '';
    },

    getItemId(item) {
        return item?.dataset.accordionId || '';
    },

    isOpen(item) {
        const key = this.getItemKey(item);

        return key !== '' && this.openItems.includes(key);
    },

    toggle(item) {
        if (this.isOpen(item)) {
            this.close(item);
            return;
        }

        this.open(item);
    },

    open(item, updateHash = true) {
        const key = this.getItemKey(item);

        if (key === '') {
            return;
        }

        if (!this.openItems.includes(key)) {
            this.openItems.push(key);
        }

        if (updateHash) {
            this.updateHash(item);
        }
    },

    close(item) {
        const key = this.getItemKey(item);

        this.openItems = this.openItems.filter((openKey) => openKey !== key);

        if (this.getCurrentHash() === this.getItemId(item)) {
            this.clearHash();
        }
    },

    openHashItem() {
        const hash = this.getCurrentHash();

        if (hash === '') {
            return;
        }

        const item = this.getItems().find((accordionItem) => this.getItemId(accordionItem) === hash);

        if (item) {
            this.open(item, false);
        }
    },

    getCurrentHash() {
        try {
            return decodeURIComponent(window.location.hash.replace(/^#/, ''));
        } catch (error) {
            return window.location.hash.replace(/^#/, '');
        }
    },

    updateHash(item) {
        const id = this.getItemId(item);

        if (id === '' || this.getCurrentHash() === id) {
            return;
        }

        history.pushState(null, '', `#${encodeURIComponent(id)}`);
    },

    clearHash() {
        history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    },
});
